import {useEffect, useState} from 'react';

import {Filter} from 'search/SearchConstants';

interface Actions {
  onChangeQuery: (query: string) => void;
  onChangeFilters: (filters: Array<Filter>) => void;
  onChangeRequestedJoinOrganizationIds: (
    organizationIds: Array<string> | ((organizationIds: Array<string>) => void)
  ) => void;
}
interface State {
  query: string;
  filters: Array<Filter>;
  hasSearched: boolean;
  requestedJoinOrganizationIds: Array<string>;
}

/**
 * React hook to track state of JoinOrganizationSearch
 */
export function useJoinOrganizationSearch(onInitialUpdate?: () => void): [State, Actions] {
  const [query, setQuery] = useState('');
  const [filters, setFilters] = useState<Array<Filter>>([]);
  const [hasSearched, setHasSearched] = useState(false);
  const [requestedJoinOrganizationIds, setRequestedJoinOrganizationIds] = useState<Array<string>>([]);

  useEffect(() => {
    if ((query.length || filters.length) && !hasSearched) {
      setHasSearched(true);
      if (onInitialUpdate) {
        onInitialUpdate();
      }
    }
  }, [query, filters, hasSearched, onInitialUpdate]);

  return [
    {query, filters, hasSearched, requestedJoinOrganizationIds},
    {
      onChangeQuery: setQuery,
      onChangeFilters: setFilters,
      onChangeRequestedJoinOrganizationIds: setRequestedJoinOrganizationIds,
    },
  ];
}
